// AuthState.js
let authState = {
  account: null,
  roles: [],
  isSignedIn: false,
};

export function setAuthState(partial) {
  authState = { ...authState, ...partial };
}

export function getAuthState() {
  return authState;
}
